<template>
    <div class="retail-configurator">
        <configurator v-bind:size="size" />
    </div>
</template>

<style scoped>
.retail-configurator ::v-deep .holder {
    display: none;
}

.retail-configurator ::v-deep .error {
    font-size: 13px;
    font-weight: 600;
    position: absolute;
    text-align: center;
    width: 100%;
}
</style>

<script>
export const RetailConfigurator = {
    name: "retail-configurator",
    props: {
        size: {
            type: Number,
            required: true
        }
    }
};

export default RetailConfigurator;
</script>
